module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Fagus/Kanagawa_Fagus_GFDL_RCP26_End.png";